import { render, staticRenderFns } from "./ForestEditHeader.vue?vue&type=template&id=d2acc240&scoped=true&"
import script from "./ForestEditHeader.vue?vue&type=script&lang=ts&"
export * from "./ForestEditHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ForestEditHeader.vue?vue&type=style&index=0&id=d2acc240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2acc240",
  null
  
)

export default component.exports